import history from './history';

export default {
  appendValue(key, value) {
    const urlParams = this.getParams();
    const pathname = this.getPathname();

    const existingValues = urlParams.getAll(key);
    const existingValueIndex = existingValues.findIndex((existingValue) => existingValue === String(value));
    const isExistingValue = existingValueIndex >= 0;

    if (isExistingValue) {
      const updatedValues = existingValues.splice(existingValueIndex, 1);
      urlParams.delete(key);
      updatedValues.forEach((updatedValue) => urlParams.append(key, updatedValue));
    } else {
      urlParams.append(key, value);
    }

    const url = `${pathname}?${urlParams.toString()}`;

    return history.push(url);
  },
  deleteValue(key) {
    const urlParams = this.getParams();
    const pathname = this.getPathname();

    const existingValue = urlParams.get(key);

    if (existingValue) {
      urlParams.delete(key);

      const url = `${pathname}?${urlParams.toString()}`;

      return history.push(url);
    }
  },
  getParams(search = window.location.search) {
    return new URLSearchParams(search);
  },
  getPathname() {
    const { location } = window;
    return location.pathname;
  },
  getValue(key) {
    const urlParams = this.getParams();

    return urlParams.get(key);
  },
  getValues(key) {
    const urlParams = this.getParams();

    return urlParams.getAll(key);
  },
  setValue(key, value) {
    const urlParams = this.getParams();
    const pathname = this.getPathname();

    const existingValues = urlParams.getAll(key);
    const existingValueIndex = existingValues.findIndex((existingValue) => existingValue === String(value));
    const isExistingValue = existingValueIndex >= 0;

    if (isExistingValue) {
      urlParams.delete(key);
    } else {
      urlParams.set(key, value);
    }

    const url = `${pathname}?${urlParams.toString()}`;

    return history.push(url);
  },
};
